import { updateManualCheckAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from 'store/createAsyncSlice';

export const { slice: updateManualCheckSlice, asyncAction: updateManualCheckAction } = createAsyncSlice(
  'updateManualCheckSlice',
  updateManualCheckAsync
);
